'use client';

import { useState } from 'react';

type FaqItem = {
  question: string;
  answer: string;
};

const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'За какие услуги списываются средства?',
    answer:
      'Средства списываются за каждую генерацию: изображение, видео, музыку или развёрнутый ответ ИИ. Стоимость зависит от выбранной модели, разрешения и длительности — итог всегда показывается до запуска, неожиданных списаний нет.',
  },
  {
    question: 'Что такое токены и как они тратятся?',
    answer:
      'Токены — это «валюта» нейросети для генерации текста. 1000 токенов ≈ 350–400 слов на русском и ≈ 750 слов на английском. При каждом запросе оплачивается не только ваш новый вопрос, но и вся история переписки (контекст), чтобы ИИ не терял нить разговора.',
  },
  {
    question: 'Почему модель пишет, что она GPT-4, хотя используется GPT-5?',
    answer:
      'Это особенность самих моделей: их обучающие данные зафиксированы и версия в ответах может устареть. Мы подключаем свежие версии через API провайдера, поэтому ориентируйтесь на название модели в интерфейсе, а не на её самоописание.',
  },
  {
    question: 'Как выполняется оплата?',
    answer:
      'Пополнить баланс можно картой через YooKassa или Telegram Stars прямо внутри Telegram-бота и Mini App. Все платежи проходят через защищённые платёжные шлюзы, данные карты мы не храним.',
  },
  {
    question: 'Есть ли бесплатный доступ?',
    answer:
      'При регистрации мы даём приветственный баланс, которого хватает, чтобы попробовать генерации и пообщаться с ИИ. Дальше можно выбрать подписку или разовые пакеты — подписка выгоднее для регулярного использования.',
  },
];

function PlusIcon({ open }: { open: boolean }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden
      className="transition-transform duration-300"
      style={{ transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
    >
      <path
        d="M6.667 16h18.666"
        stroke="#fafafa"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6.667v18.666"
        stroke="#fafafa"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FaqRow({ item, index }: { item: FaqItem; index: number }) {
  const [open, setOpen] = useState(false);
  const number = String(index + 1).padStart(2, '0');

  return (
    <div className="overflow-hidden bg-[#2a2c31]">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-6 px-3 py-[18px] text-left transition-colors hover:bg-[#30333a] md:gap-20 md:px-3"
      >
        <div className="flex min-w-0 flex-1 items-center gap-4">
          <span
            className="shrink-0 font-mono text-base font-bold text-[#ffa207]"
            style={{ letterSpacing: '-0.2px' }}
          >
            {number}
          </span>
          <span
            className="min-w-0 flex-1 font-mono text-sm font-bold text-white md:text-base"
            style={{ letterSpacing: '-0.2px', lineHeight: 1.45 }}
          >
            {item.question}
          </span>
        </div>
        <span className="shrink-0">
          <PlusIcon open={open} />
        </span>
      </button>

      <div
        className="grid transition-[grid-template-rows,opacity] duration-400 ease-out"
        style={{
          gridTemplateRows: open ? '1fr' : '0fr',
          opacity: open ? 1 : 0,
        }}
      >
        <div className="overflow-hidden">
          <div
            className="px-3 pb-[22px] pl-[58px] pr-3 text-base text-white/85 md:text-lg"
            style={{ letterSpacing: '-0.4px', lineHeight: 1.6 }}
          >
            {item.answer}
          </div>
        </div>
      </div>
    </div>
  );
}

export function FaqSection() {
  return (
    <section className="relative overflow-hidden bg-black">
      <div className="mx-auto max-w-[1440px] px-5 pb-28 pt-16 md:px-[230px] md:pb-40 md:pt-[120px]">
        <div className="flex flex-col gap-[31px]">
          <div className="flex flex-col gap-[19px]">
            <h1 className="font-display text-3xl font-bold leading-[1.275] text-white md:text-[40px]">
              Частые вопросы
            </h1>
          </div>
          <hr className="border-0 border-t border-[#25272a]" />
        </div>

        <div className="mt-[23px] flex flex-col gap-1">
          {FAQ_ITEMS.map((item, idx) => (
            <FaqRow key={item.question} item={item} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}
